export default "<div #animatedDigit class=\"animated-digit\">\r\n  <span>{{digit}}</span>\r\n</div>\r\n";